import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, paginate } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'profiles'

const superAdminGetList = (axios: IFactoryFunctionRequest<paginate<{ display: string; level: 1 | 2 | 3 }>, any>) => (query: { page: number; limit: number; display?: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/superAdminList`,
    query,
  })
}

/** Screen a profile is given from: its own « Peut attribuer » right unlocks Admin profiles there */
export type TProfileGrantContext = 'hire' | 'hrCreate'

const getAllowProfiles = (axios: IFactoryFunctionRequest<paginate<{ display: string; level: 1 | 2 | 3; isLocked: boolean }>, any>) => (query: { page: number; limit: number; search?: string; context?: TProfileGrantContext }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query,
  })
}

const superAdminGetOne = (axios: IFactoryFunctionRequest<{ display: string }, any>) => (profileId) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/superAdminGetEdit/${profileId}`,
  })
}

const superAdminUpdateOne = (axios: IFactoryFunctionRequest<any, any>) => (profileId, profile) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${profileId}`,
    data: profile,
  })
}

const superAdminDeleteOne = (axios: IFactoryFunctionRequest<any, any>) => (profileId: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${profileId}`,
  })
}

const importAccessRights = (axios: IFactoryFunctionRequest<any, any>) => ({ profileIds = [], allProfiles = false }) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/importAccessFromV1`,
    query: { allProfiles, profileIds },
  })
}


const paginatedResourceWithProfile = (axios: IFactoryFunctionRequest<paginate<{_id: string, firstname: string, lastname: string, }>, any>) => (profileId: string, query: { page: number; limit: number }) => {

  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/resourcesWithProfile/${profileId}`,
    query,
  })
}

const createProfile = (axios: IFactoryFunctionRequest<any, any>) => (data: { display?: string; preset?: string } = {}) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data,
  })
}

const duplicateProfile = (axios: IFactoryFunctionRequest<any, any>) => (profileId: string) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/duplicate/${profileId}`,
  })
}

const batchUpdateModules = (axios: IFactoryFunctionRequest<{ updated: number; matched: number }, any>) => (data: { profileIds: string[]; updates: Record<string, boolean | string> }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/batch-update-modules`,
    data,
  })
}

export default (axios: AxiosInstance) => ({
  superAdminGetList: superAdminGetList(useAxios(axios)),
  superAdminGetOne: superAdminGetOne(useAxios(axios)),
  superAdminUpdateOne: superAdminUpdateOne(useAxios(axios)),
  superAdminDeleteOne: superAdminDeleteOne(useAxios(axios)),
  getAllowProfiles: getAllowProfiles(useAxios(axios)),
  importAccessRights: importAccessRights(useAxios(axios)),
  paginatedResourceWithProfile: paginatedResourceWithProfile(useAxios(axios)),
  createProfile: createProfile(useAxios(axios)),
  duplicateProfile: duplicateProfile(useAxios(axios)),
  batchUpdateModules: batchUpdateModules(useAxios(axios)),

})
